export function isGenericMobile() {
  return /Mobile/.test(navigator.userAgent);
}
export function isAndroid() {
  return /Android/.test(navigator.userAgent);
}
export function isBlackBerry() {
  return /BlackBerry/.test(navigator.userAgent);
}
export function isIOS() {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}
export function isOperaMobile() {
  return /Opera Mini/.test(navigator.userAgent);
}
export function isWindowsMobile() {
  return /IEMobile/.test(navigator.userAgent);
}
export function isMobile() {
  return this.isGenericMobile() ||
    this.isIOS() ||
    this.isAndroid() ||
    this.isBlackBerry() ||
    this.isOperaMobile() ||
    this.isWindowsMobile();
}
export function isMobileViewPort() {
  return window.matchMedia(
    `(max-height: ${this.mediaQuerySetting.MOBILE_LANDSCAPE_MAX_HEIGHT_PX}px) ` +
    'and (orientation: landscape)'
  ).matches ||
  window.matchMedia(
    `(max-width: ${this.mediaQuerySetting.TABLET_MIN_WIDTH_PX}px) and (orientation: portrait)`
  ).matches;
}
export function isIE11() {
  const ua = window.navigator.userAgent;
  const trident = ua.indexOf('Trident/');
  let rv;
  if (trident > 0) {
    // IE 11
    rv = ua.indexOf('rv:');
    if (parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) === 11) {
      return true;
    }
  }
  // not IE11
  return false;
}
export function viewportWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}
export function isTablet() {
  return window.screen.width >= this.mediaQuerySetting.TABLET_MIN_WIDTH_PX &&
    window.screen.width < this.mediaQuerySetting.DESKTOP_MIN_WIDTH_PX;
}
export function isDesktop() {
  return window.screen.width >= this.mediaQuerySetting.DESKTOP_MIN_WIDTH_PX;
}
export const mediaQuerySetting = {
  MOBILE_LANDSCAPE_MAX_HEIGHT_PX: 460,
  TABLET_MIN_WIDTH_PX: 600,
  DESKTOP_MIN_WIDTH_PX: 1025
};
export const Supports = {
  /** @returns boolean */
  geolocation: function() {
    return !!navigator.geolocation;
  }
};
